export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_CUSTOMER_PROFILE = 'GET_CUSTOMER_PROFILE';
export const GET_CUSTOMER_PREFERENCE = 'GET_CUSTOMER_PREFERENCE';
